<script>
import {defineComponent} from 'vue'
import {goodsDetail, goodsList, paiDetail} from "../api/api";
import router from "../router";
export default defineComponent({
  name: "productDetail",
  data() {
    return{
      id:'',
      dataObj:{},
      page:1,
      total:null,
      list:[],
	  type:null
    }
  },
  mounted(){
    this.id = this.$route.query.id
	if(this.$route.query.type) {
		this.type = this.$route.query.type
	}
    console.log(this.id,'打印id')
    // this.GoodsDetail()
    this.paiDetail()
    this.hdList()
  },
  methods:{
    pageChange(e){
      console.log(e)
      this.page = e
      this.hdList()
    },
    handleChange(){
      this.page = 1
      this.hdList()
    },

    hdList(){
      goodsList({
        pai_time_id: this.id,
        page: this.page,
		limit:"10000"
      }).then(res => {
        this.list = res.data.data.list.data
        this.total = res.data.data.list.total
        console.log(this.list,'列表打印+-')
        // this.classArr2 = res.data.data.list
      })
    },
    GoodsDetail(){
      goodsDetail({
        id:this.id

      }).then(res => {
        this.dataObj = res.data.data.info
        console.log(res,'打印r')
      })
    },
    paiDetail(){
		console.log('jjjjjjjjjjjjjjjjjj')
      paiDetail({
        pai_time_id:this.id

      }).then(res => {
        this.dataObj = res.data.data.info
        console.log(res,'打印r')

      })
    },
    go(name,e){
      console.log('打印aaaaaaaaaaaaaa')
      router.push(
        {
          name,
          query:{
            id:e.id,
			type: this.type == 2 ? 2 : null
          }
        }
      )
    },
  }
})
</script>

<template>
  <div>
    <section id="about-us" class="padding-large no-padding-top">
      <div class="container">
        <div class="row d-flex flex-wrap align-items-center justify-content-between">
          <div class="col-md-6">
            <div class="image-holder mb-4">
              <div>
                <img :src="dataObj.image" alt="single" class="single-image img-fluid">
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="detail ps-5">
              <div class="display-header">
                <p class="pb-3">{{dataObj.sku}}</p>
                <h2>{{dataObj.title}}</h2>
                <div style="margin-top: 40px">
				  <!-- <p class="pb-3">{{dataObj.describe}}</p> -->
                  <p class="pb-3">拍卖时间：{{dataObj.pai_time.split(' ')[0]}}</p>
                  <p class="pb-3">项目负责：{{dataObj.admin}}</p>
                  <p class="pb-3">拍卖地点: {{dataObj.address}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="blog-section" class=" padding-large">
      <div class="container" >
        <div class="row">
          <div class="post-item col-md-3" style="position:relative;" v-for="(item,index) in list" :key="item.id" @click="go('productDetail',item)">
<!--            <div class="status1" v-if="item.status == 1">-->
<!--              预展中-->
<!--            </div><div class="status1" v-if="item.status == 2">-->
<!--            拍卖中-->
<!--          </div><div class="status1" v-if="item.status == 3">-->
<!--            竞价中-->
<!--          </div><div class="status1" v-if="item.status == 4">-->
<!--            已成交-->
<!--          </div><div class="status1" v-if="item.status == 5">-->
<!--            等待预展-->
<!--          </div>-->
            <figure class="zoom-effect">
              <div  class="zoom-in"><img :src="item.image" alt="stories" class="lgpostImg img-fluid"></div>
            </figure>
            <div class="story-title-wrap mt-3">
				<div class="post-meta" style="color: gray;">LOT:{{item.describe}}</div>
              <h4 class="story-title">{{item.title}}</h4>
              
              <div class="post-meta" v-if="type == 2">成交价：{{item.price}} RMB</div>
              <div class="post-meta">拍卖地点：{{item.address}}</div>
              <div class="post-meta">拍卖时间{{item.pai_time}}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="list.length > 10">
      <div class="container">
        <div class="row">
          <div style="display: flex;justify-content: space-between">
            <div></div>
            <div>
              <el-pagination
                background
                :page-size='10'
                layout="prev, pager, next"
                @current-change="pageChange"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/changciDetail.vue